export default __webpack_public_path__ + "static/media/a011-PPII-3.5eaa2b65.svg";